<template>
  <div
    id="main-body"
    :class="{ [$route.query?.referrer ?? '']: true }"
    class="min-h-screen flex flex-col"
  >
    <PublicSiteNavBar v-if="!noBrandActive" />
    <ModalTender v-if="isNewTender && newTender.state.modalOpen" />
    <JoszakiToastContainer />
    <JoszakiAlert />
    <JoszakiConfirm />
    <Nuxt />
    <TheFooter v-if="!noBrandActive" />
  </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";
import ModalTender from "~/components/newTender/ModalTender.vue";
import JoszakiAlert from "~/components/joszaki/JoszakiAlert.vue";
import JoszakiToastContainer from "~/components/_refactored/common/JoszakiToastContainer.vue";
import PublicSiteNavBar from "~/components/_refactored/header/PublicSiteNavBar.vue";
import JoszakiConfirm from "~/components/joszaki/JoszakiConfirm.vue";
import TheFooter from "~/components/_refactored/TheFooter.vue";
import { useNewTender } from "~/composables/tender/useNewTender";
import { useNoBrandActive } from "~/composables/useNoBrandActive";

export default defineComponent({
  components: {
    PublicSiteNavBar,
    ModalTender,
    JoszakiAlert,
    JoszakiToastContainer,
    JoszakiConfirm,
    TheFooter,
  },
  setup() {
    const newTender = useNewTender();

    return {
      newTender,
      noBrandActive: useNoBrandActive(),
    };
  },
  computed: {
    isNewTender() {
      return (
        this.$ab.isVariant("new-tender-2", "variant1") ||
        this.$ab.isVariant("new-tender-2", "variant2")
      );
    },
  },
});
</script>
